import { render, staticRenderFns } from "./fourthPage.vue?vue&type=template&id=f4ea6296&scoped=true"
import script from "./fourthPage.vue?vue&type=script&lang=js"
export * from "./fourthPage.vue?vue&type=script&lang=js"
import style0 from "./fourthPage.vue?vue&type=style&index=0&id=f4ea6296&prod&scoped=true&lang=css"
import style1 from "./fourthPage.vue?vue&type=style&index=1&id=f4ea6296&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ea6296",
  null
  
)

export default component.exports